import c from "./consts";

export default {
  [c.HOURLY_FORECAST](state, value) {
    state[c.HOURLY_FORECAST] = value;
  },

  [c.AVAILABLE_MODELS](state, value) {
    state[c.AVAILABLE_MODELS] = value;
  },

  [c.SELECTED_MODEL](state, value) {
    state[c.SELECTED_MODEL] = value;
  },

  [c.LOCATIONS](state, value) {
    state[c.LOCATIONS] = value;
  },

  [c.SELECTED_LOCATION](state, value) {
    state[c.SELECTED_LOCATION] = value;
  },

  [c.MODEL_FORECAST](state, value) {
    state[c.MODEL_FORECAST] = value;
  },

  [c.SYNOPTIC_FORECAST](state, value) {
    state[c.SYNOPTIC_FORECAST] = value;
  },

  [c.AI_FORECAST](state, value) {
    state[c.AI_FORECAST] = value;
  },

  [c.MIRINE_FORECAST](state, value) {
    state[c.MIRINE_FORECAST] = value;
  },

  [c.RADAR_SADG](state, value) {
    state[c.RADAR_SADG] = value;
  },

  [c.RADAR_DALN](state, value) {
    state[c.RADAR_DALN] = value;
  },

  [c.WARNING](state, value) {
    state[c.WARNING] = value;
  },

  [c.AMK_DATA](state, value) {
    state[c.AMK_DATA] = value;
  },

  [c.GRAPH_DATA](state, value) {
    state[c.GRAPH_DATA] = value;
  },

  [c.LOCATION_COORDINATES](state, value) {
    state[c.LOCATION_COORDINATES] = value;
  },

  [c.GRIB_CLOUD](state, value) {
    state[c.GRIB_CLOUD] = value;
  },

  [c.GRIB_ALL](state, value) {
    state[c.GRIB_ALL] = value;
  },

  [c.CURRENT_FORECAST](state, value) {
    state[c.CURRENT_FORECAST] = value;
  },

  [c.IS_LOADING](state, value) {
    state[c.IS_LOADING] = value;
  },
  [c.SYN_MAPS](state, payload) {
    state[c.SYN_MAPS] = payload;
  },
  [c.WAVE_LOCATIONS](state, value) {
    state[c.WAVE_LOCATIONS] = value;
  },
  [c.SELECTED_WAVE_LOCATION](state, payload) {
    state[c.SELECTED_WAVE_LOCATION] = payload;
  },
  [c.WAVE_FORECAST](state, value) {
    state[c.WAVE_FORECAST] = value;
  },
  [c.TYPHOON_GEOJSON](state, value) {
    state[c.TYPHOON_GEOJSON] = value;
  },
}